var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-panel-content grid grid__base", class: _vm.bemFacets },
    [
      _vm._l(_vm.items, function(item, idx) {
        return [
          item.items && item.items.length > 0
            ? _c(
                "accordion-item",
                {
                  key: idx,
                  staticClass: "nav-panel-content--item",
                  attrs: {
                    facets: ["mobile-nav", _vm.isActiveFacet(item)],
                    label: item.label,
                    "is-open": _vm.isAccordionOpen(item, idx)
                  },
                  on: {
                    open: function($event) {
                      _vm.onOpen(idx)
                    },
                    close: _vm.onClose
                  }
                },
                [
                  _c("base-icon", {
                    attrs: {
                      slot: "icon",
                      symbol: "chevron-down",
                      size: "large"
                    },
                    slot: "icon"
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "nav-panel-content--child-wrapper" },
                    _vm._l(item.items, function(child, cIdx) {
                      return _c(
                        "navigation-entry",
                        _vm._b(
                          {
                            key: cIdx,
                            staticClass: "nav-panel-content--child",
                            attrs: { facets: ["mobile-nav"] }
                          },
                          "navigation-entry",
                          child,
                          false
                        )
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  item.show_all_label
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "nav-panel-content--overview-btn btn btn__primary-green btn__has-grid btn__medium",
                          attrs: { href: item.path }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(item.show_all_label) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                {
                  key: idx,
                  staticClass:
                    "nav-panel-content--item nav-panel-content--direct-link"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "nav-panel-content--container grid--container"
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "u-reset nav-panel-content--item-link",
                          class: _vm.directLinkActive(item),
                          attrs: { href: item.path }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.label) +
                              "\n                "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90dbd050", { render: render, staticRenderFns: staticRenderFns })
  }
}